import React, { useContext, useState } from "react";

import cn from "classnames"

import as from "../styles/auth-styles.module.scss"

import { AUTH_FLOW_COMPONENTS, AuthContext } from "../contexts/Auth";

import PasswordVisibilityIcon from "./icons/PasswordVisibilityIcon"

const RegistrationForm = () => {

    const [passwordVisible, setPasswordVisible] = useState(false)
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false)
    const [validClassCode, setIsValidClassCode] = useState(true)
    const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible)
    const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisible(!confirmPasswordVisible)

    const {
        getClassCodes,
        setCurrAuthComponent,
        registerErrorMsg,
        registerUserWithEmailAndPassword
    } = useContext(AuthContext)

    const alreadyHaveAccount = (event) => {
        event.preventDefault()
        setCurrAuthComponent(AUTH_FLOW_COMPONENTS.LOGIN)
        // console.log("I already have an account")
    }

    const handleSignUp = async (event) => {
        event.preventDefault();
        const validClassCodes = await getClassCodes()
        const { classCode, email, password } = event.target.elements;
        if (validClassCodes.includes(classCode.value)) {
            registerUserWithEmailAndPassword(email.value, password.value, classCode.value);
        } else {
            setIsValidClassCode(false)
        }
    }

    return (
        <div>
            <form onSubmit={handleSignUp}>
                <div className={as.container}>
                    <div className={as.row}>
                        <h3>Sign up for MedDBriefer</h3>
                    </div>
                    <div className={as.row}>
                        <label
                            htmlFor="classCode"
                            className={cn(as['col-sm-3'], as['col-form-label'])}
                        >
                            Class Code
                        </label>
                        <div className={as["col-sm-9"]}>
                            <input
                                className={as['form-control']}
                                id="classCode"
                                name="classCode"
                                type="text"
                                placeholder="example: demo"
                                autoComplete="off"
                                onInput={() => setIsValidClassCode(true)}
                                required
                            />
                        </div>
                    </div>
                    <div className={as.row} style={{display: validClassCode ? "none" : "block"}}>
                        <div className={as['col-sm-12']}>
                            <span className={as['text-danger']}>
                                Invalid class code, if you are here for an experiment, type 'pilot', otherwise enter 'demo'
                            </span>
                        </div>
                    </div>
                    <div className={cn(as.row, )}>
                        <label
                            htmlFor="emailAddress"
                            className={cn(as['col-sm-3'], as['col-form-label'])}
                        >
                            Email
                        </label>
                        <div className={as["col-sm-9"]}>
                            <input
                                className={as['form-control']}
                                id="emailAddress"
                                name="email"
                                type="email"
                                placeholder="example: john.doe@gmail.com"
                                required
                            />
                        </div>
                    </div>
                    <div className={as.row}>
                        <label
                            htmlFor="password"
                            className={cn(as['col-sm-3'], as['col-form-label'])}
                        >
                            Password
                        </label>
                        <div className={cn(as['col-sm-9'], as["input-group"])}>
                            <input
                                id="password"
                                name="password"
                                type={passwordVisible ? "text" : "password"}
                                className={as['form-control']}
                                placeholder="Enter password"
                                required
                            />
                            <PasswordVisibilityIcon
                                visible={passwordVisible}
                                stateToggler={togglePasswordVisibility}
                            />
                        </div>
                    </div>
                    <div className={as.row}>
                        <label
                            htmlFor="confirmPassword"
                            className={cn(as['col-sm-3'], as['col-form-label'])}
                        >
                            Confirm Password
                        </label>
                        <div className={cn(as["col-sm-9"], as["input-group"])}>
                            <input
                                className={as['form-control']}
                                id="confirmPassword"
                                name="confirmPassword"
                                type={confirmPasswordVisible ? "text" : "password"}
                                placeholder="Password"
                                required
                            />
                            <PasswordVisibilityIcon
                                visible={confirmPasswordVisible}
                                stateToggler={toggleConfirmPasswordVisibility}
                            />
                        </div>
                    </div>
                    <div className={as.row}>
                        <p className={as['text-danger']}>
                            {registerErrorMsg}
                        </p>
                    </div>

                    <button
                        type="submit"
                        className={cn(as.btn, as['btn-primary'])}
                    >
                        Sign Up
                    </button>
                    <button
                        type="button"
                        className={cn(as.btn, as['btn-link'])}
                        onClick={alreadyHaveAccount}
                    >
                        I already have an account.
                    </button>
                </div>
            </form>
        </div>
    )
}

export default RegistrationForm